import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {FormItemComponentInterface} from '../../../../interface/component';
import {FormEventService} from '../../../../services/formEventService';
import {MatSelectChange} from '@angular/material/select';

@Component({
    selector: 'noos-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss']
})
@NoosFormTypeService.register('dropdown')
export class DropdownComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor(private eventListenerService: FormEventService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
    }

    onSelect($event: MatSelectChange) {
        this.eventListenerService.updatedDataSelection({
            fromComponentId: this.prop.id,
            fromComponentName: this.prop.name,
            eventName: 'select',
            triggerValue: $event.value,
            formId: this.formId,
            datasetId: this.datasetId
        });
    }
}
